const BLOCKED_PROCESSES = {
    Sale: {
        isBlocked: false,
        h1: 'Obecnie opcja "Rozpocznij czat" jest niedostępna.',
        p: 'Jeśli potrzebujesz wsparcia w zakresie doboru oferty, kliknij "Zadzwoń".',
        MOAppVersionException: '5.74.0.11377'
    },
    Support: {
        isBlocked: false,
        h1: 'Zanim przejdziesz do czatu, uaktualnij wersję aplikacji.',
        p: 'Szybko zrobisz to w App Storze lub Google Play.',
        MOAppVersionException: '5.74.0.11377'
    }
};

const isProcessBlocked = ({ processName, MOAppVersion, blockedProcesses = BLOCKED_PROCESSES }) => {
    if (!processName) {
        return false;
    }

    const blockedProcess = blockedProcesses[processName];
    if (!blockedProcess) {
        return false;
    }

    if (!blockedProcess.isBlocked) {
        return false;
    }

    if (MOAppVersion && MOAppVersion === blockedProcess.MOAppVersionException) {
        return false;
    }

    return true;
};

const setBlockedProcessMessage = (processName) => {
    if (!processName) {
        return;
    }

    const blockedProcess = BLOCKED_PROCESSES[processName];
    if (!blockedProcess) {
        return;
    }

    const messagesContainer = document.getElementById('messages');
    if (!messagesContainer) {
        return;
    }

    const mainContainer = document.getElementById('main');
    mainContainer.style.display = 'none';

    const closerWidgetContainer = document.getElementById('closer-widget');
    closerWidgetContainer.style.display = 'none';

    if (blockedProcess.h1) {
        const h1 = document.createElement('h1');
        const h1Content = document.createTextNode(blockedProcess.h1);
        h1.appendChild(h1Content);
        messagesContainer.appendChild(h1);
    }
    if (blockedProcess.p) {
        const p = document.createElement('p');
        const pContent = document.createTextNode(blockedProcess.p);
        p.appendChild(pContent);
        messagesContainer.appendChild(p);
    }
    messagesContainer.style.display = 'block';
};

export { isProcessBlocked, setBlockedProcessMessage };
